import CustomerLayout from "../../layouts/UserLayout";
import Profile from '../../components/Profile';

const UserProfile = () => {

    return (
        <CustomerLayout>
            <Profile />
        </CustomerLayout>

    )
}

export default UserProfile
